import { toPx } from '@max/leez-style-util';
export const GIFT_STYLE = {
    width: toPx(14),
    height: toPx(14)
};
export const FIRE_SOURCE = {
    uri: 'https://p0.meituan.net/ingee/43ae3472a93e373fedde901e0b058ad61118.png',
    width: toPx(12.5),
    height: toPx(12.5)
};
export const IN_THIS_NEW_SOURCE = {
    uri: 'https://p0.meituan.net/ingee/c711485e98390824abd287cedad6c92e11103.png',
    width: toPx(97),
    height: toPx(24)
};
export const THE_THOUSAND_AND_ONE_NIGHTS_LIVE_SOURCE = {
    uri: 'https://p0.meituan.net/ingee/f7bb873e0763f2859666ddb97a4f60c023039.png',
    width: toPx(97),
    height: toPx(24)
};
export const POSITION_ICON = {
    uri: 'https://p0.meituan.net/ingee/42f82db3756e48cdb0f7ae46fc6c95cb818.png',
    width: toPx(12),
    height: toPx(12)
};
export const BUTTON_BG_SOURCE = {
    uri: 'https://p0.meituan.net/ingee/27c1435ba36a772bdaf194de418952eb26399.png',
    width: '100%',
    height: 88
};
export const NEW_BUTTON_BG_SOURCE = {
    uri: 'https://p0.meituan.net/travelcube/2ed7414953d2e16f4b6d446bf196c96842943.png',
    width: toPx(276 / 2),
    height: toPx(82 / 2)
};
export const PROMOTION_ICON = {
    uri: 'https://p0.meituan.net/travelcube/c451c7acd655c90d27480a05683ac8ba543.png',
    width: toPx(20 / 2),
    height: toPx(20 / 2)
};
export const DEFAULT_FRONT_IMG = {
    uri: 'https://p0.meituan.net/travelcube/c893f3f4eb0e7cc187e56f2c8ef49f24104432.png',
    width: toPx(300 / 2),
    height: toPx(163 / 2)
};
